import { UserPayload, VerifyOtpType } from "../../types";
import { CHANGE_PASSWORD, DELETE_ACCOUNT , DELETE_PROFILE, GET_PROFILE, LOGIN_URL, LOGOUT_URL, SEND_OTP, SEND_OTP_TO_UPDATE_PHONE_EMAIL, SIGNUP_URL, TWO_FACT_AUTH, UPDATE_FORGOT_PASSWORD, UPDATE_PROFILE, VERIFY_OTP, VERIFY_OTP_TO_UPDATE_PHONE_EMAIL, VERIFY_SIGNUP } from "../common/constant";
import { AxiosRequest } from "../common/axios-request";

const AuthLogin = (payload: UserPayload) => {
  return AxiosRequest.post(LOGIN_URL, payload);
};

const LogoutUser = () => {
  return AxiosRequest.post(LOGOUT_URL, {});
};

const GetCurrentUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);

  return null;
};

const AuthOtpVerification = (payload: any) => {
  return AxiosRequest.post(TWO_FACT_AUTH, payload);
};

const SendOTP = (payload: any) => {
  return AxiosRequest.post(SEND_OTP, payload)
}

const AuthResetPassword = (payload: any) => {
  return AxiosRequest.post(UPDATE_FORGOT_PASSWORD, payload)
}

const DeleteAccount = (payload: any) => {
  return AxiosRequest.delete(DELETE_ACCOUNT, payload)
}

const ChangeUserPassword = (payload: any) => {
  return AxiosRequest.put(CHANGE_PASSWORD, payload)
}

const UpdateUserProfile = (payload: any) => {
  return AxiosRequest.put(UPDATE_PROFILE, payload)
}

const GetUserProfile = () => {
  return AxiosRequest.get(GET_PROFILE)
}

const VerifyOTP = (payload: VerifyOtpType) => {
  return AxiosRequest.post(VERIFY_OTP, payload)
}

const SendOtpToUpdatePhoneEmail = (payload: any) => {
  return AxiosRequest.post(SEND_OTP_TO_UPDATE_PHONE_EMAIL, payload)
}

const VerifyOtpToUpdatePhoneEmail = (payload: any) => {
  return AxiosRequest.post(VERIFY_OTP_TO_UPDATE_PHONE_EMAIL, payload)
}

const SignupUser = (payload: any) => {
  return AxiosRequest.post(SIGNUP_URL, payload)
}

const VerifySignup = (payload: any) => {
  return AxiosRequest.post(VERIFY_SIGNUP, payload)
}

const DeleteProfile = (payload: any) => {
  return AxiosRequest.delete(DELETE_PROFILE, payload)
}

export {
  AuthLogin,
  LogoutUser,
  GetCurrentUser,
  AuthOtpVerification,
  SendOTP,
  AuthResetPassword,
  ChangeUserPassword,
  UpdateUserProfile,
  GetUserProfile,
  VerifyOTP,
  SendOtpToUpdatePhoneEmail,
  VerifyOtpToUpdatePhoneEmail,
  SignupUser,
  VerifySignup,
  DeleteProfile,
  DeleteAccount
};
